import { Stack, Typography } from "@mui/material";
import { useParams } from "react-router";
import { useObjectDefinitionContext } from "../ObjectDefinitionContext";

const ObjectLayoutPageTitle = () => {
  const { configurationId } = useParams();
  const { objectDefinition, configurations } = useObjectDefinitionContext();

  const configurationName = configurations.find((c) => c.id === configurationId)?.name ?? "";

  return (
    <Stack spacing={0.5} sx={{ py: 2 }}>
      <Typography variant="h6">{objectDefinition.objectName}</Typography>
      {configurationName && (
        <Typography variant="caption" color="textSecondary">
          {configurationName} configuration
        </Typography>
      )}
    </Stack>
  );
};

export default ObjectLayoutPageTitle;
